import { FC } from 'react';
import {
  Datagrid,
  DateInput,
  FilterButton,
  List,
  ListProps,
  SearchInput,
  TextField,
  TextInput,
  TopToolbar,
} from 'react-admin';
import TimeAgoField from 'components/TimeAgoField';
import TruncatedTextField from 'components/TruncatedTextField';
import ChipListField from './ChipListField';

const UnitErrorFilters = [
  <SearchInput key="q" source="q" alwaysOn />,
  <TextInput key="message" source="message" label="Message" />,
  <DateInput key="from" source="from" label="From" />,
  <DateInput key="to" source="to" label="To" />,
];

const UnitErrorListActions = () => (
  <TopToolbar>
    <FilterButton />
  </TopToolbar>
);

const UnitErrorList: FC<ListProps> = () => {
  return (
    <List
      perPage={25}
      filters={UnitErrorFilters}
      exporter={false}
      sort={{ field: 'count', order: 'DESC' }}
      actions={<UnitErrorListActions />}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TruncatedTextField source="message" maxLength={60} label="Message" />
        <TextField source="count" label="Occurrences" />
        <TextField source="unique_units" label="Unique units" />
        <ChipListField source="hardware_types" label="Hardware type(s)" max={3} />
        <ChipListField source="software_releases" label="Software release(s)" max={3} />
        <TimeAgoField source="last_seen" label="Last seen" />
      </Datagrid>
    </List>
  );
};

export default UnitErrorList;
